import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { ErrorState } from '@/components/ui/states'
import { LumoraSignature } from './signature'

/** Replaces React Router's default error screen (e.g. a chunk that failed to load after an update). */
export function RouteError() {
  const { t } = useTranslation()
  return (
    <main id="main" tabIndex={-1} className="mx-auto flex min-h-dvh max-w-page flex-col px-6 pb-8 pt-6">
      <div className="flex items-center gap-3">
        <img src="/icons/icon.svg" alt="" aria-hidden width={40} height={40} className="size-10 rounded-[10px]" />
        <LumoraSignature size="lg" />
      </div>
      <ErrorState page title={t('states.error.title')} />
      <div className="flex justify-center">
        <Button className="w-full max-w-sm" onClick={() => window.location.reload()}>{t('states.error.reloadPage')}</Button>
      </div>
    </main>
  )
}
